var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDf2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 104,
    viewBox: "0 0 136 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2137_3780)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1294 68.9255H16.509V95.5611H19.1294V68.9255Z",
    fill: "#FF88AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4713 51.8577C15.4713 50.5048 16.5614 49.4077 17.9057 49.4077C19.25 49.4077 20.3401 50.5048 20.3401 51.8577C20.3401 53.2105 17.9057 67.2298 17.9057 67.2298C17.9057 67.2298 15.4713 53.2105 15.4713 51.8577Z",
    fill: "#C4D035"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71262 77.1273C4.54913 77.805 3.05808 77.4015 2.38723 76.2306C1.71377 75.0571 2.1147 73.5592 3.2782 72.884C4.44431 72.2063 17.7249 67.3196 17.7249 67.3196C17.7249 67.3196 6.87873 76.4521 5.71524 77.1273H5.71262Z",
    fill: "#C4D035"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3366 72.9973C33.5001 73.6751 33.9011 75.173 33.2276 76.3439C32.5568 77.5175 31.0657 77.9183 29.9022 77.2406C28.7361 76.5628 17.89 67.4329 17.89 67.4329C17.89 67.4329 31.1705 72.3196 32.3366 72.9973Z",
    fill: "#C4D035"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1 67.4593C21.1 69.2868 19.6273 70.7716 17.8087 70.7716C15.9901 70.7716 14.5174 69.2895 14.5174 67.4593C14.5174 65.6291 15.9901 64.147 17.8087 64.147C19.6273 64.147 21.1 65.6291 21.1 67.4593Z",
    fill: "#FF7543"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8794 52.575V34.9058H37.4728V18.0278H33.28V34.9058H29.8734V52.575H25.1566V95.5611H45.3342V52.575H40.8794Z",
    fill: "#FF7543"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2318 58.9043H28.5632V62.3326H32.2318V58.9043Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2318 65.4973H28.5632V68.9257H32.2318V65.4973Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2318 72.0903H28.5632V75.5187H32.2318V72.0903Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M117.885 55.634H97.7044V95.6797H117.885V55.634Z",
    fill: "#FBCD00"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M114.515 58.9041H110.846V62.3324H114.515V58.9041Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M114.515 65.4971H110.846V68.9254H114.515V65.4971Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M114.515 72.0901H110.846V75.5184H114.515V72.0901Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M107.177 58.9041H103.509V62.3324H107.177V58.9041Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M107.177 65.4971H103.509V68.9254H107.177V65.4971Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M107.177 72.0901H103.509V75.5184H107.177V72.0901Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M103.509 49.4104H77.566V95.5611H103.509V49.4104Z",
    fill: "#FF88AE"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7437 52.575H82.807V55.4759H97.7437V52.575Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7437 58.9043H82.807V62.0689H97.7437V58.9043Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7437 65.761H82.807V68.9256H97.7437V65.761Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7437 72.354H82.807V75.5186H97.7437V72.354Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3191 49.4104H35.3764V95.5611H61.3191V49.4104Z",
    fill: "#FF88AE"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5541 52.575H40.8794V55.4759H55.5541V52.575Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5541 58.9043H40.8794V62.0689H55.5541V58.9043Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5541 65.761H40.8794V68.9256H55.5541V65.761Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5541 72.3538H40.8794V75.5184H55.5541V72.3538Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0469 33.3156C51.0469 32.2317 51.9195 31.3535 52.9965 31.3535C54.0735 31.3535 54.9461 32.2317 54.9461 33.3156C54.9461 34.3995 54.0735 35.2776 52.9965 35.2776C51.9195 35.2776 51.0469 34.3995 51.0469 33.3156Z",
    fill: "#C4D035"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7277 30.1588C49.8205 29.0591 51.3299 28.3787 52.9965 28.3787C54.6631 28.3787 56.1725 29.0591 57.2626 30.1588",
    stroke: "#C4D035",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2383 27.6534C47.9678 25.9129 50.355 24.8369 52.9965 24.8369C55.6379 24.8369 58.0226 25.9129 59.7521 27.6534",
    stroke: "#C4D035",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5162 95.6771V28.6162C77.5162 22.8434 72.8649 18.1624 67.1287 18.1624H55.8423V95.6771H77.5136H77.5162Z",
    fill: "#B176FF"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6835 28.0491H71.801V41.7624H74.6835V28.0491Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9185 28.0491H66.0359V41.7624H68.9185V28.0491Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6835 49.4104H71.801V63.1238H74.6835V49.4104Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9185 49.4104H66.0359V63.1238H68.9185V49.4104Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M106.318 21.8649C105.941 20.9999 105.107 20.214 104.172 20.0215C104.214 18.6581 103.328 17.2656 101.515 17.2656C100.849 17.2656 100.162 17.5504 99.7379 17.9856C99.4627 17.8959 99.1745 17.8458 98.8338 17.8458C97.2825 17.8458 96.3575 19.109 96.3103 20.4091C96.1478 20.3696 96.0011 20.3485 95.8281 20.3485C94.8638 20.3485 94.0331 20.9893 93.7265 21.8649H106.318Z",
    fill: "#A4E7E2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1275 27.0945C35.1275 27.0629 35.1327 27.0312 35.1327 26.9996C35.1327 25.7996 34.1422 24.8001 32.9499 24.7949C32.9499 24.7738 32.9525 24.7553 32.9525 24.7342C32.9525 24.1646 32.7245 23.6134 32.3262 23.2126C31.9279 22.8117 31.3776 22.5823 30.8116 22.5823C30.2455 22.5823 29.6979 22.8117 29.2996 23.2126C28.9012 23.6161 28.6733 24.1672 28.6733 24.7342C28.6733 25.1219 28.7807 25.5016 28.9746 25.8313C28.7964 25.8577 28.6261 25.9157 28.4662 26.0106C28.0758 26.2427 27.8111 26.6462 27.7535 27.0945H35.1275Z",
    fill: "#A4E7E2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M136 59.1549C135.95 58.9729 135.877 58.7909 135.764 58.6406C135.405 58.1712 135.387 58.1026 134.886 57.7677C134.569 57.5831 134.226 57.4855 133.862 57.4671C133.862 57.0899 133.775 56.7207 133.579 56.3858C133.199 55.7344 132.491 55.323 131.739 55.323C131.48 55.323 131.225 55.3731 130.987 55.4654C130.644 54.9591 130.075 54.6057 129.278 54.6057C127.418 54.6057 126.794 56.5361 127.407 57.831C127.198 57.8679 126.993 57.9391 126.807 58.0472C126.393 58.2925 126.097 58.696 125.977 59.1549H136.003H136Z",
    fill: "#A4E7E2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5654 45.0115C61.5156 44.8296 61.4423 44.6476 61.3296 44.4973C60.9706 44.0279 60.9522 43.9593 60.4517 43.6244C60.1347 43.4398 59.7914 43.3422 59.4271 43.3237C59.4271 42.9466 59.3406 42.5774 59.1441 42.2425C58.7641 41.5911 58.0566 41.1797 57.3045 41.1797C57.0451 41.1797 56.7909 41.2298 56.5525 41.3221C56.2092 40.8158 55.6405 40.4624 54.8439 40.4624C52.9834 40.4624 52.3597 42.3928 52.9729 43.6877C52.7633 43.7246 52.5589 43.7958 52.3728 43.9039C51.9588 44.1492 51.6627 44.5527 51.5421 45.0115H61.568H61.5654Z",
    fill: "#A4E7E2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4713 32.1737C15.4766 32.0497 15.4975 31.9231 15.5316 31.8018C15.7569 30.9738 16.4907 30.4885 17.2663 30.4806C17.2742 29.9769 17.4786 29.489 17.8324 29.1304C18.194 28.7664 18.6893 28.5607 19.2002 28.5607C19.533 28.5607 19.8606 28.6478 20.1462 28.8113C20.3768 28.0254 21.011 27.3977 21.7971 27.1815C22.219 27.0681 22.6409 27.0681 23.0628 27.1815C23.4664 27.2949 23.8175 27.5006 24.1136 27.7986C24.1215 27.8065 24.1294 27.8118 24.1372 27.8197C24.4307 28.1177 24.6325 28.4658 24.7452 28.8693C24.8552 29.278 24.8578 29.6894 24.753 30.0982C24.8998 30.1272 25.0387 30.18 25.1723 30.2564C25.1933 30.267 25.2142 30.2802 25.2352 30.2907C25.6335 30.5122 25.8798 30.9685 25.8798 31.4221C25.8798 31.6858 25.796 31.9522 25.6466 32.171H15.4687L15.4713 32.1737Z",
    fill: "#A4E7E2"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2407 44.136H88.572V48.0918H92.2407V44.136Z",
    fill: "#34ACBF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2196 47.8281H84.1172V49.4104H97.2196V47.8281Z",
    fill: "#34ACBF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7138 30.4226H84.0989C82.3723 30.4226 80.9727 31.8312 80.9727 33.5688V41.781C80.9727 43.5185 82.3723 44.9271 84.0989 44.9271H96.7138C98.4404 44.9271 99.8401 43.5185 99.8401 41.781V33.5688C99.8401 31.8312 98.4404 30.4226 96.7138 30.4226Z",
    fill: "#C8F1EE"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9998 33.0598H83.5931V36.7519H86.9998V33.0598Z",
    fill: "#34ACBF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2407 33.0598H88.572V36.7519H92.2407V33.0598Z",
    fill: "#34ACBF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4816 33.0598H94.075V36.7519H97.4816V33.0598Z",
    fill: "#34ACBF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9998 38.0706H83.5931V41.7626H86.9998V38.0706Z",
    fill: "#34ACBF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2407 38.0706H88.572V41.7626H92.2407V38.0706Z",
    fill: "#34ACBF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4816 38.0706H94.075V41.7626H97.4816V38.0706Z",
    fill: "#34ACBF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M100.54 21.973L103.325 20.3617L102.012 17.4107L105.209 17.7561L105.867 14.5889L108.252 16.7619L110.636 14.5889L111.297 17.7561L114.491 17.4107L113.181 20.3617L115.966 21.973L113.181 23.5843L114.491 26.5379L111.297 26.1898L110.636 29.3571L108.252 27.1867L105.867 29.3571L105.209 26.1898L102.012 26.5353L103.325 23.5843L100.54 21.973Z",
    fill: "#FF7543"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M103.999 21.973C103.999 19.6101 105.904 17.6929 108.252 17.6929C110.6 17.6929 112.505 19.6101 112.505 21.973C112.505 24.3359 110.6 26.2532 108.252 26.2532C105.904 26.2532 103.999 24.3359 103.999 21.973Z",
    fill: "#FBCD00"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M125.971 42.5037C125.958 42.0448 125.584 41.4989 125.13 41.4989H125.104C125.08 41.4989 125.06 41.6888 125.039 41.6888C124.965 41.2853 124.85 40.9873 124.695 40.6181C124.714 40.6075 124.735 40.6445 124.753 40.6339C125.149 40.3887 125.272 39.8876 125.028 39.4894C124.444 38.5374 123.618 37.762 122.641 37.2267C122.232 37.0025 121.721 37.1607 121.498 37.5721C121.488 37.5906 121.483 37.6143 121.472 37.6354C121.097 37.4983 120.707 37.406 120.301 37.3533C120.301 37.3322 120.306 37.3111 120.306 37.29C120.295 36.8205 119.905 36.4513 119.444 36.4619C118.33 36.4883 117.237 36.8074 116.286 37.3875C115.888 37.6302 115.762 38.1523 116.003 38.5505C116.014 38.569 116.032 38.5822 116.042 38.6006C115.733 38.8591 115.455 39.1518 115.209 39.4736C115.191 39.4604 115.172 39.4445 115.154 39.434C114.748 39.2072 114.234 39.3496 114.009 39.7584C113.487 40.7051 113.212 41.7705 113.212 42.8571V42.8755C113.22 43.3397 113.595 43.6034 114.054 43.6034H114.067C114.082 43.6034 114.098 43.6588 114.114 43.6588C114.179 44.0965 114.297 44.5449 114.457 44.9431C114.439 44.9536 114.418 44.9747 114.397 44.9853C113.998 45.2253 113.867 45.7527 114.103 46.1535C114.672 47.1161 115.487 47.9178 116.454 48.469C116.585 48.5428 116.726 48.5798 116.868 48.5798C117.161 48.5798 117.447 48.4268 117.602 48.1499C117.612 48.1314 117.617 48.1103 117.628 48.0892C118 48.2316 118.39 48.3345 118.797 48.3925C118.797 48.411 118.791 48.4901 118.791 48.5086C118.794 48.9753 119.171 49.4026 119.633 49.4026H119.64C120.757 49.4026 121.852 49.0386 122.811 48.4743C123.212 48.2396 123.348 47.6963 123.112 47.2902C123.102 47.2717 123.086 47.2401 123.076 47.2242C123.388 46.9684 123.673 46.6731 123.925 46.3566C123.943 46.3698 123.959 46.3803 123.977 46.3909C124.111 46.4674 124.255 46.5017 124.397 46.5017C124.687 46.5017 124.97 46.3487 125.128 46.0744C125.681 45.1066 125.974 43.9093 125.974 42.7859C125.974 42.7199 125.974 42.5643 125.974 42.4984L125.971 42.5037ZM116.939 42.8834C116.939 41.4093 118.126 40.2146 119.591 40.2146C121.055 40.2146 122.242 41.4093 122.242 42.8834C122.242 44.3576 121.055 45.5523 119.591 45.5523C118.126 45.5523 116.939 44.3576 116.939 42.8834Z",
    fill: "#C4D035"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M130.895 31.4248C130.714 31.1716 130.345 31.0767 130.088 31.2507C130.083 31.2534 130.078 31.256 130.075 31.2613C130.062 31.2692 130.075 31.314 130.062 31.3219C129.868 31.1215 129.666 30.9633 129.441 30.8129C129.449 30.7998 129.462 30.7945 129.467 30.7813C129.598 30.4912 129.472 30.1537 129.184 30.0218C128.495 29.708 127.732 29.5814 126.978 29.6526C126.663 29.6816 126.433 29.9638 126.461 30.2829C126.461 30.2987 126.467 30.3119 126.469 30.3277C126.207 30.3936 125.95 30.4912 125.701 30.6152C125.694 30.602 125.688 30.5888 125.681 30.5756C125.497 30.3145 125.138 30.2565 124.881 30.4385C124.26 30.8789 123.765 31.4775 123.448 32.1685C123.314 32.4586 123.44 32.8014 123.728 32.9332C123.741 32.9385 123.757 32.9412 123.77 32.9464C123.694 33.2101 123.647 33.4844 123.629 33.7587C123.613 33.7587 123.597 33.7587 123.582 33.7587C123.264 33.7851 123.029 34.062 123.057 34.3784C123.12 35.1116 123.367 35.8183 123.778 36.4328L123.833 36.5119C124.011 36.7703 124.37 36.8468 124.63 36.6701C124.632 36.6701 124.635 36.6675 124.638 36.6649C124.648 36.6596 124.63 36.6148 124.638 36.6068C124.839 36.8284 125.052 37.0024 125.293 37.1659C125.285 37.1791 125.272 37.1817 125.264 37.1949C125.128 37.4824 125.248 37.8226 125.534 37.9597C126.218 38.2841 126.978 38.4239 127.732 38.3632C127.835 38.3553 127.926 38.3184 128.008 38.2656C128.173 38.1522 128.275 37.9571 128.259 37.7408C128.259 37.725 128.254 37.7118 128.251 37.696C128.513 37.6327 128.775 37.543 129.024 37.4191C129.032 37.4296 129.119 37.5668 129.126 37.58C129.305 37.841 129.74 38.0309 130.002 37.8542C130.002 37.8542 130.004 37.8542 130.004 37.8516C130.636 37.4244 131.055 36.7071 131.383 36.0214C131.522 35.7339 131.362 35.3304 131.076 35.1907C131.063 35.1854 131.026 35.1485 131.013 35.1432C131.094 34.8795 131.136 34.592 131.157 34.3178C131.173 34.3178 131.181 34.3125 131.197 34.3125C131.301 34.3046 131.393 34.2677 131.474 34.2123C131.639 34.1015 131.739 33.9037 131.726 33.6901C131.674 32.9306 131.409 32.179 130.984 31.5434C130.961 31.5065 130.924 31.4538 130.898 31.4169L130.895 31.4248ZM125.89 35.0219C125.335 34.1885 125.552 33.0598 126.38 32.5007C127.208 31.9417 128.33 32.1605 128.885 32.9939C129.441 33.8273 129.223 34.956 128.395 35.515C127.567 36.0741 126.446 35.8552 125.89 35.0219Z",
    fill: "#FF7543"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18272 42.8174H3.56122C1.59441 42.8174 0 44.422 0 46.4013V56.1114C0 58.0908 1.59441 59.6954 3.56122 59.6954H7.18272C9.14953 59.6954 10.7439 58.0908 10.7439 56.1114V46.4013C10.7439 44.422 9.14953 42.8174 7.18272 42.8174Z",
    fill: "#34ACBF"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90959 45.4546H1.57227V54.6847H8.90959V45.4546Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1.57227 54.6847V45.4546H8.90959",
    fill: "#A4E7E2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M6.40179 57.1188C6.40179 57.7465 5.89604 58.2554 5.27237 58.2554C4.6487 58.2554 4.14294 57.7465 4.14294 57.1188C4.14294 56.4912 4.6487 55.9822 5.27237 55.9822C5.89604 55.9822 6.40179 56.4912 6.40179 57.1188Z",
    fill: "#34ACBF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M127.725 68.9255H118.076C116.109 68.9255 114.515 70.5301 114.515 72.5095V76.1541C114.515 78.1334 116.109 79.738 118.076 79.738H127.725C129.691 79.738 131.286 78.1334 131.286 76.1541V72.5095C131.286 70.5301 129.691 68.9255 127.725 68.9255Z",
    fill: "#FF7543"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M131.244 74.7985V72.6597C131.244 72.512 131.233 72.367 131.215 72.2219H114.504C114.486 72.3643 114.475 72.5094 114.475 72.6597V74.7985H131.244Z",
    fill: "#B176FF"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1383 10.1162V15.3906",
    stroke: "#C4D035",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7799 12.7534H81.7588",
    stroke: "#C4D035",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7931 5.14515C71.7931 9.85252 66.6806 14.014 66.6806 14.014C66.6806 14.014 61.5681 9.63364 61.5681 5.14515C61.5681 2.30226 63.8584 0 66.6806 0C69.5029 0 71.7931 2.3049 71.7931 5.14515Z",
    fill: "#FF88AE"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3142 5.1452C69.3142 6.60883 68.135 7.7982 66.678 7.7982C65.221 7.7982 64.0418 6.61147 64.0418 5.1452C64.0418 3.67892 65.221 2.49219 66.678 2.49219C68.135 2.49219 69.3142 3.67892 69.3142 5.1452Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M120.686 87.3857H15.3166C10.7651 87.3857 7.07526 91.0991 7.07526 95.6797V95.7061C7.07526 100.287 10.7651 104 15.3166 104H120.686C125.238 104 128.927 100.287 128.927 95.7061V95.6797C128.927 91.0991 125.238 87.3857 120.686 87.3857Z",
    fill: "#34ACBF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96198 100.827C10.4714 102.742 12.8036 103.974 15.4214 103.974H120.867C123.485 103.974 125.817 102.742 127.326 100.827H8.96198Z",
    fill: "#34ACBF"
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4763 92.3965H16.4513C15.6148 92.3965 14.9367 93.0789 14.9367 93.9208V94.0368C14.9367 94.8787 15.6148 95.5611 16.4513 95.5611H25.4763C26.3128 95.5611 26.9909 94.8787 26.9909 94.0368V93.9208C26.9909 93.0789 26.3128 92.3965 25.4763 92.3965Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0593 92.3965H44.0816C44.9175 92.3965 45.5989 93.0795 45.5989 93.9234V94.0368C45.5989 94.8781 44.9202 95.5637 44.0816 95.5637H35.0593C34.2234 95.5637 33.5421 94.8807 33.5421 94.0368V93.9234C33.5421 93.0822 34.2208 92.3965 35.0593 92.3965Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9396 94.1106C63.9396 94.9545 63.2032 95.5584 62.3673 95.5584H53.4629C52.6244 95.5584 51.8854 94.9519 51.8854 94.1106V94.0157C51.8854 93.1718 52.6244 92.3938 53.4629 92.3938H62.3673C63.2032 92.3938 63.9396 93.1718 63.9396 94.0157V94.1106Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M72.008 92.3965H81.0303C81.8662 92.3965 82.5475 93.0795 82.5475 93.9234V94.0368C82.5475 94.8781 81.8688 95.5637 81.0303 95.5637H72.008C71.172 95.5637 70.4907 94.8807 70.4907 94.0368V93.9234C70.4907 93.0822 71.1694 92.3965 72.008 92.3965Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3513 92.3965H99.3736C100.21 92.3965 100.891 93.0795 100.891 93.9234V94.0368C100.891 94.8781 100.212 95.5637 99.3736 95.5637H90.3513C89.5154 95.5637 88.834 94.8807 88.834 94.0368V93.9234C88.834 93.0822 89.5128 92.3965 90.3513 92.3965Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M126.519 95.5611C126.519 92.3965 123.948 89.7593 120.728 89.7593H110.18C108.627 89.7593 107.439 90.9381 107.439 92.502V92.7736C107.439 94.3374 108.629 95.5611 110.18 95.5611H126.517H126.519Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2137_3780"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 104,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDf2);
export default __webpack_public_path__ + "static/media/df-2.2b5c3f9adb425afdb9f4e09eaa4f2978.svg";
export { ForwardRef as ReactComponent };